import { UserModel, UserDeviceStateModel, QueueModel } from '@/types';

export interface RealtimeReportServiceGetUserDevicesResult {
    id: number;
    deviceType: string;
    user: UserModel;
    state: UserDeviceStateModel;
}

export interface RealtimeReportServiceGetQueueCallsStateResult {
    uniqueId: string;
    queueModel: QueueModel;
    queue: string;
    position: number;
    channel: string;
    callerIdNum: string;
    callerIdName: string;
    connectedLineNum: string;
    connectedLineName: string;
    wait: number;
    priority: number;
    destinationNumber: string;
}
